import { EventBase } from "@vp/models";

export class TabIndexChangedEvent extends EventBase<number> {
  constructor(result: number) {
    super();
    this.args = result;
  }
}
